import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function SchemaMarkup({ salesInfo }) {
  const location = useLocation();

  useEffect(() => {
    // Remove existing schema scripts
    const existingSchemas = document.querySelectorAll('script[type="application/ld+json"]');
    existingSchemas.forEach(script => script.remove());

    // LocalBusiness Schema
    const localBusinessSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "BYD Cibubur - Bayu Akbar Bisono",
      "description": "Dealer resmi BYD Indonesia. Jual mobil listrik BYD M6, Atto 1, Seal, Dolphin, Atto 3, Sealion 7, Denza D9.",
      "url": "https://byd-mobil-keluarga.preview.emergentagent.com",
      "telephone": "+6285179752067",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Jl. Alternatif Cibubur No.41",
        "addressLocality": "Jatikarya, Jatisampurna",
        "addressRegion": "Jawa Barat",
        "postalCode": "17435",
        "addressCountry": "ID"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "-6.3625",
        "longitude": "106.9347"
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          "opens": "08:00",
          "closes": "17:00"
        }
      ],
      "priceRange": "Rp 300.000.000 - Rp 1.500.000.000",
      "image": "https://images.unsplash.com/photo-1627953385320-1ccf8610c70a?w=800"
    };

    // Product Schema for BYD M6
    const productSchemaM6 = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "BYD M6",
      "description": "MPV Listrik Keluarga Terbaik dengan kapasitas 7 penumpang dan teknologi Blade Battery",
      "brand": {
        "@type": "Brand",
        "name": "BYD"
      },
      "category": "Electric Vehicle",
      "image": "https://images.unsplash.com/photo-1716011699927-b494c8a17ed5?w=800",
      "offers": {
        "@type": "Offer",
        "url": "https://byd-mobil-keluarga.preview.emergentagent.com/mobil/byd-m6",
        "priceCurrency": "IDR",
        "price": "400000000",
        "priceValidUntil": "2026-12-31",
        "availability": "https://schema.org/InStock",
        "seller": {
          "@type": "Organization",
          "name": "BYD Cibubur"
        }
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "124"
      }
    };

    // Product Schema for BYD Atto 1
    const productSchemaAtto1 = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "BYD Atto 1",
      "description": "Compact EV Terlaris untuk mobilitas perkotaan dengan efisiensi tinggi",
      "brand": {
        "@type": "Brand",
        "name": "BYD"
      },
      "category": "Electric Vehicle",
      "image": "https://images.pexels.com/photos/261986/pexels-photo-261986.jpeg?w=800",
      "offers": {
        "@type": "Offer",
        "url": "https://byd-mobil-keluarga.preview.emergentagent.com/mobil/byd-atto-1",
        "priceCurrency": "IDR",
        "price": "300000000",
        "priceValidUntil": "2026-12-31",
        "availability": "https://schema.org/InStock",
        "seller": {
          "@type": "Organization",
          "name": "BYD Cibubur"
        }
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "reviewCount": "89"
      }
    };

    // Add schema scripts
    const addSchema = (schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
    };

    addSchema(localBusinessSchema);
    addSchema(productSchemaM6);
    addSchema(productSchemaAtto1);

    // Add canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.href = `https://byd-mobil-keluarga.preview.emergentagent.com${location.pathname}`;

  }, [location, salesInfo]);

  return null;
}
